import template from './loanqReferButton.template.html';

export default {
  template,
  bindings: {
    account: '<',
    ticket: '<',
    minimised: '<',
    af: '<',
    edit: '<',
    media: '<'
  },
  controllerAs: '$ctrl',
  controller: class controller {
    constructor($rootScope, uiService, INSTANCE) {
      'ngInject';

      const ctrl = this;
      ctrl.currentOrganization = null;

      ctrl.loanqTokens = () =>
        _.find(ctrl.account?.integrations?.loanq?.tokens, {
          id: ctrl.currentOrganization?.externalReferenceId || ''
        });

      ctrl.loanqAddress = () => {
        const lq = ctrl.loanqTokens();
        const prefix =
          INSTANCE.prefix.toLowerCase() === 'loanq' ? 'app' : INSTANCE.prefix.toLowerCase();
        return ctrl.account?.integrations?.loanq?.enabled && lq && lq?.id
          ? `https://${prefix}.loanq.com.au/#/loan-edit/${ctrl.edit ? 'old' : 'new'}?id=${
              lq.id
            }&${ctrl.edit ? 'idTicket' : 'idReferredFrom'}=${ctrl.ticket?.id}`
          : 'https://www.loanq.com.au';
      };

      ctrl.$onInit = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.url = ctrl.loanqAddress();
      };
    }
  }
};
